"use strict";
var ChartConst = (function () {
    function ChartConst() {
    }
    ChartConst.LINE_CHART_TYPE_NAME = 'line';
    ChartConst.BAR_CHART_TYPE_NAME = 'bar';
    ChartConst.PIE_CHART_TYPE_NAME = 'pie';
    ChartConst.SCATTER_PLOT_CHART_TYPE_NAME = 'scatterPlot';
    ChartConst.HISTOGRAM_CHART_TYPE_NAME = 'histogram';
    ChartConst.STACK_BAR_CHART_TYPE_NAME = 'stackBar';
    ChartConst.GEO_MAP_CHART_TYPE_NAME = 'geoMap';
    ChartConst.GEO_ORTHOGRAPHIC_CHART_TYPE_NAME = 'geoOrthographic';
    ChartConst.TREE_MAP_CHART_TYPE_NAME = 'treeMap';
    ChartConst.PACK_LAYOUT_CHART_TYPE_NAME = 'packLayout';
    ChartConst.CHOROPLETH_CHART_TYPE_NAME = 'choropleth';
    ChartConst.TREE_CHART_TYPE_NAME = 'tree';
    ChartConst.SANKEY_CHART_TYPE_NAME = 'sankey';
    ChartConst.FORCE_CHART_TYPE_NAME = 'force';
    return ChartConst;
}());
exports.ChartConst = ChartConst;
//# sourceMappingURL=chart-const.js.map


//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/o2-chart-lib/dist/src/o2chart/shared/chart-const.js
// module id = ../../../../o2-chart-lib/dist/src/o2chart/shared/chart-const.js
// module chunks = 3